export const REGEX = {
  NUMBER: /^[0-9]+$/,
  FLOAT: /^-?[0-9]\d*(\.\d+)?$/,
  EMAIL:
    /^[-A-Za-z0-9_]+[-A-Za-z0-9_.]*[@]{1}[-A-Za-z0-9_]+[-A-Za-z0-9_.]*[.]{1}[A-Za-z]{1,5}$/,
  PHONE: /^\d{2,3}\d{3,4}\d{4}$/,
  PHONE_WITH_HYPHEN: /^\d{2,3}-\d{3,4}-\d{4}$/,
  BIRTHDAY: /^(19[0-9][0-9]|20\d{2})(0[0-9]|1[0-2])(0[1-9]|[1-2][0-9]|3[0-1])$/,
  BIRTHDAY_WITH_HYPHEN:
    /^(19[0-9][0-9]|20\d{2})-(0[0-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$/,
  TIME_HHMM: /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/,
  THOUSAND_COMMA: /^\d{1,3}(,\d{3})*$/,
  IP: /^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/,
  DATE_WITH_HYPHEN: /^\d{4}-\d{2}-\d{2}$/,
};
